import CreateOrganization from "../pages/CreateOrganization";
import EditOrganization from "../pages/EditOrganization";
import Home from "../pages/HomePage";
import Organization from "../pages/Organization";
import OrganizationList from "../pages/OrganizationList";
import Profile from "../pages/profile";
import ResetPassword from "../pages/ResetPassword";
import ProjectBoard from "../pages/projectBoard";
import ProjectBoardStg from "../pages/projectBoard-stg.js";
import Assets from "../pages/Assets";
import StyleGuide from "../pages/StyleGuide";
import Invoices from "../pages/Invoices";
import UserOrganization from "../pages/userPages/userOrganization";
import CreateFolder from "../pages/createFolder";
import FreeVideo from "../pages/FreeVideo";
import TaskReport from "../pages/TaskReport";
import Templates from "../pages/userPages/Templates";
import AdminTemplates from "../pages/adminPages/AdminTemplates";
import FirstFifty from "../pages/FirstFifty";
import FirstFiftyOnboarding from "../pages/FirstFiftyOnboarding";
import EditorManagement from "../pages/adminPages/EditorManagement";
import EditorDetail from "../pages/adminPages/EditorDetail";
import EditorPaymentDetail from "../pages/EditorPages/EditorPaymentDetail.js";
import SSOLoginPage from "../pages/SSOLoginPage.js";
import NewsletterListPage from "../pages/NewsletterListPage.js";
import OrgNewsletterListPage from "../pages/OrgNewsletterListPage.js";
import SignupPage from "../pages/SignupPage.js";
import CreateAccount from "../pages/CreateAccount.js";
// import BuyPlan from "../pages/userPages/BuyPlan.js";
import Subscriptions from "../pages/userPages/Subscriptions.js";
import SubscriberList from "../pages/adminPages/SubscriberList.js";
import PrivacyPolicy from "../pages/PrivacyPolicy.js";
import Login from "../pages/Login.js";
import RedirectPage from "../pages/RedirectPage.js";
import SelectOrganization from "../pages/SelectOrganization.js";
import MeetingList from "../pages/MeetingList.js";
import InviteSignup from "../pages/InviteSignup.js";
import SpecialOffer from "../pages/SpecialOffer.js";
import AvatarPage from "../pages/AvatarPage";
import AskParis from "../pages/AskParis";
import AskParisConversations from "../pages/adminPages/AskParisConversations";
import TestPage from "../pages/TestPage";
import PublicAiStudio from "../pages/public-ai-studio/PublicAiStudio.js";

// Public Routes (No authentication required)
export const publicRoutes = [
    {
        path: "/",
        element: <Home />
    },
    {
        path: "/free-video",
        element: <FreeVideo />
    },
    {
        path: "/first-50",
        element: <FirstFifty />
    },
    {
        path: "/organization/invite/:token",
        element: <InviteSignup />
    },
    {
        path: "/first-50/onboarding",
        element: <FirstFiftyOnboarding />
    },
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "/sso-login",
        element: <SSOLoginPage />
    },
    {
        path: "/signup",
        element: <SignupPage />
    },
    {
        path: "/create/account",
        element: <CreateAccount />
    },
    {
        path: "/privacy-policy",
        element: <PrivacyPolicy />
    },
    {
        path: "/redirect/dashboard",
        element: <RedirectPage />
    },
    {
        path: "/select-organization",
        element: <SelectOrganization />
    },
    {
        path: "/special-offer",
        element: <SpecialOffer /> 
    },
    {
        path: "/ask-paris",
        element: <AskParis />
    },
    {
        path: "/test",
        element: <TestPage />
    },
    {
        path: "/ai-studio",
        element: <PublicAiStudio />
    },
];

export const publicRoutesForSecondLayout = [
    {
        path: "/reset/password/:token",
        element: <ResetPassword />
    },
];

// Admin Routes
export const adminRoutes = [
    {
        path: "/profile",
        element: <Profile />
    },
    {
        path: "/org/:id/avatars",
        element: <AvatarPage />
    },
    {
        path: "/org/:id/projects",
        element: <Organization />
    },
    {
        path: "/org/:id/project/view/:projectId",
        element: <ProjectBoard />
    },
    {
        path: "/org/:id/project/view/:projectId/stg",
        element: <ProjectBoardStg />
    },
    {
        path: "/org/:id/assets",
        element: <Assets />
    },
    {
        path: "/org/:id/styleguide",
        element: <StyleGuide />
    },
    {
        path: "/org/:id/invoices",
        element: <Invoices />
    },
    {
        path: "/org/:id/create/folder/:boxFolderId",
        element: <CreateFolder />
    },
    {
        path: "/org/:orgId/newsletter/list",
        element: <OrgNewsletterListPage />
    },
    {
        path: "/task/list",
        element: <TaskReport />
    },
    {
        path: "/manage/templates",
        element: <AdminTemplates />
    },
    {
        path: "/manage/editors",
        element: <EditorManagement />
    },
    {
        path: "/manage/editor/:editorId",
        element: <EditorDetail />
    },
    {
        path: "/editor/profile",
        element: <EditorPaymentDetail />
    },
    {
        path: "/newsletter/list",
        element: <NewsletterListPage />
    },
    {
        path: "/subscription/list",
        element: <SubscriberList />
    },
    {
        path: "/org/meetings",
        element: <MeetingList />
    },
    {
        path: "/ask-paris/conversations",
        element: <AskParisConversations />
    },
    // {
    //     path: "/org/:id/subscribe/plan",
    //     element: <Subscriptions />
    // },
];

export const adminRouteForSecondLayout = [
    {
        path: "/organization/list",
        element: <OrganizationList />
    },
    {
        path: "/create/organization",
        element: <CreateOrganization />
    },
    {
        path: "/organization/edit/:id",
        element: <EditOrganization />
    },
]

// User Routes
export const userRoutes = [
    {
        path: "/profile",
        element: <Profile />
    },
    {
        path: "/org/:id/avatars",
        element: <AvatarPage />
    },
    {
        path: "/org/:id/projects",
        element: <UserOrganization />
    },
    {
        path: "/org/:id/project/view/:projectId",
        element: <ProjectBoard />
    },
    {
        path: "/org/:id/project/view/:projectId/stg",
        element: <ProjectBoardStg />
    },
    {
        path: "/org/:id/assets",
        element: <Assets />
    },
    {
        path: "/org/:id/create/folder/:boxFolderId",
        element: <CreateFolder />
    },
    {
        path: "/org/:id/templates",
        element: <Templates />
    },
    {
        path: "/org/:orgId/newsletter/list",
        element: <OrgNewsletterListPage />
    },
    {
        path: "/org/:id/subscribe/plan",
        // element: <BuyPlan />
        element: <Subscriptions />
    },
    // {
    //     path: "/org/:id/meetings",
    //     element: <MeetingList />
    // },
];
